const BLOCKED_ACTIONS = [
    "auto_save",
    "auto_post",
    "auto_delete",
    "payment_trigger",
    "bank_payment_trigger",
    "salary_disbursement",
    "execute_salary_transfer",
    "gst_filing",
    "voucher_posting",
    "role_mutation",
    "secret_mutation",
    "token_mutation",
    "api_key_update",
    "formula_change",
    "formula_mutation",
    "irreversible_delete",
    "external_send",
    "whatsapp_send",
    "email_send",
    "github_write",
    "oauth_token_exchange"
];
const HIGH_RISK_CONFIRMATION_REQUIRED = [
    "export_pdf",
    "generate_report",
    "draft_disbursement",
    "create_invoice_draft",
    "create_voucher_draft",
    "create_estimate_draft",
    "sync_preview"
];
const SAFE_ACTIONS = [
    "calculate",
    "preview",
    "explain",
    "summarize",
    "validate",
    "read_metadata",
    "route_help",
    "form_help"
];
/**
 * Classifies the risk level of a tool action.
 */
export function classifyToolActionRisk(actionId) {
    if (BLOCKED_ACTIONS.includes(actionId)) {
        return "critical";
    }
    if (HIGH_RISK_CONFIRMATION_REQUIRED.includes(actionId)) {
        return "high";
    }
    if (SAFE_ACTIONS.includes(actionId)) {
        return "safe";
    }
    return "medium";
}
/**
 * Checks if an action is blocked/dangerous.
 */
export function isDangerousAction(actionId) {
    return BLOCKED_ACTIONS.includes(actionId);
}
/**
 * Evaluates whether an action on a tool integration is allowed or blocked.
 */
export function guardToolAction(tool, actionId) {
    if (!tool) {
        return {
            ok: false,
            status: "unknown_tool",
            toolId: "unknown",
            actionId,
            riskLevel: "critical",
            reason_hi: "प्रदाता या टूल विन्यास अनुपस्थित है।",
            warnings: []
        };
    }
    const toolId = tool.toolId || tool.integrationId || "unknown";
    const allowedActions = tool.allowedActions || [];
    const blockedActions = tool.blockedActions || [];
    const riskLevel = classifyToolActionRisk(actionId);
    const warnings = [];
    // 1. Explicitly blocked in metadata
    if (blockedActions.includes(actionId)) {
        return {
            ok: false,
            status: "blocked",
            toolId,
            actionId,
            riskLevel,
            reason_hi: `सुरक्षा नीति उल्लंघन: '${actionId}' क्रिया को स्पष्ट रूप से ब्लॉक किया गया है।`,
            warnings
        };
    }
    // 2. Globally dangerous action blocked by default
    if (isDangerousAction(actionId)) {
        return {
            ok: false,
            status: "blocked",
            toolId,
            actionId,
            riskLevel: "critical",
            reason_hi: `सुरक्षा नीति उल्लंघन: '${actionId}' एक संवेदनशील या हानिकारक क्रिया है और इसे स्वतः ब्लॉक किया गया है।`,
            warnings
        };
    }
    // 3. Not in allowedActions
    if (!allowedActions.includes(actionId)) {
        return {
            ok: false,
            status: "unknown_action",
            toolId,
            actionId,
            riskLevel,
            reason_hi: `सुरक्षा नीति उल्लंघन: '${actionId}' क्रिया इस टूल के स्वीकृत क्रियाओं (allowedActions) में शामिल नहीं है।`,
            warnings
        };
    }
    // 4. Requires manual confirmation (High Risk)
    if (riskLevel === "high") {
        return {
            ok: true,
            status: "confirmation_required",
            toolId,
            actionId,
            riskLevel,
            reason_hi: `'${actionId}' एक उच्च-जोखिम वाली क्रिया है और इसके निष्पादन के लिए मैनुअल पुष्टि (manual confirmation) की आवश्यकता है।`,
            warnings
        };
    }
    // 5. Allowed safe action
    return {
        ok: true,
        status: "allowed",
        toolId,
        actionId,
        riskLevel,
        reason_hi: `'${actionId}' क्रिया सुरक्षित है और निष्पादन के लिए स्वीकृत है।`,
        warnings
    };
}
/**
 * Evaluates whether an action on a resolved tool runtime integration is allowed or blocked.
 */
export function guardToolRuntimeAction(resolvedTool, actionId) {
    return guardToolAction(resolvedTool, actionId);
}
//# sourceMappingURL=toolActionGuard.js.map